






















































import Vue from 'vue';
import { AppConstants } from '@/app.constants';
import { isAdmin } from '../../../store';

export default Vue.extend({
    computed: {
        isAdmin: isAdmin,
    },
    methods: {
        logout: function(event) {
            localStorage.removeItem(AppConstants.LocalStorageKeys.jwt);
            window.location.reload();
        },
        gotoSignups: function(event) {
            this.$router.push({ name: 'admin' });
        },
        gotoCampaigns: function(event) {
            this.$router.push({ name: 'campaigns' });
        },
        gotoSettings: function(event) {
            this.$router.push({ name: 'settings' });
        },
    },
});
